import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function HomeworkSubmissionsPage() {
  return <InstituteCrudPage config={entityConfigs['homework-submissions']} />;
}
